import { render, staticRenderFns } from "./TopicR.vue?vue&type=template&id=7e95fa1a"
import script from "./TopicR.vue?vue&type=script&lang=js"
export * from "./TopicR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports